import React from 'react'
import { CheckboxProps, FormControlLabel } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { ConditionalTooltipCheckbox as ConditionalTooltipCheckboxBase } from 'src/Components/Checkbox'

interface Props extends Omit<CheckboxProps, 'checked' | 'name' | 'onChange'> {
  name: string
  label: React.ReactNode
  disabled: boolean
  disableReason: string
}

/**
 * Conditional tooltip checkbox integrated with react-hook-form.
 */
const ConditionalTooltipCheckbox: React.FC<Props> = ({ name, label, disableReason, disabled, ...props }) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <ConditionalTooltipCheckboxBase
              {...props}
              name={name}
              checked={field.value ?? false}
              disabled={disabled}
              disableReason={disableReason}
              onChange={(_event, checked) => field.onChange(checked)}
            />
          }
          label={label}
        />
      )}
    />
  )
}

ConditionalTooltipCheckbox.displayName = 'ConditionalTooltipCheckbox'

export default ConditionalTooltipCheckbox
